import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import ProductosInventarioData from '../../Components/Admin/ProductosInventarioData/ProductosInventarioData';
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { fetchUsuario, getUsuario } from '../../Components/user';

export default function ProductosInventario() {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    return (
        <div className='containerGrid'>

            <Header />

            <section className='containerSection'>

                <HeaderDash />

                <div className='container'>

                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario ? (
                        <>
                            {(usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'colaborador') ? (
                                <ProductosInventarioData />
                            ) : (
                                <SinPermisos />
                            )}
                        </>
                    ) : (
                        <ProductosInventarioData />
                    )}

                </div>

            </section>

        </div>
    );
}